import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Sidebar;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
/* eslint "jsx-a11y/click-events-have-key-events": "warn" */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { IconMoveStartLine, IconMoveEndLine, IconPinSolid, IconQuizInstructionsLine, IconQuizTitleLine } from '@instructure/ui-icons';
import { AccessibleContent, PresentationContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import { IconButton } from '@instructure/ui-buttons';
import { Link } from '@instructure/ui-link';
import { Text } from '@instructure/ui-text';
import { View } from '@instructure/ui-view';
import { jsx, Global } from '@instructure/emotion';
import { Heading } from '@instructure/ui-heading';
import t from '@instructure/quiz-i18n/es/format-message';
import { Tooltip } from '@instructure/ui-tooltip';
import { INSTRUCTIONS_SCROLL_KEY, RESULTS_SCROLL_KEY, SIDEBAR_NAV_ID, TITLE_SCROLL_KEY, END_EDITING_TRIGGER_CLASSNAME, withStyleOverrides } from '@instructure/quiz-common';
import { onPhone } from '../../../../util/windowChecks';
import CustomPropTypes from '../../../../util/CustomPropTypes';
import noop from '../../../../util/noop';
import Pin from './Pin';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var Sidebar = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Sidebar = /*#__PURE__*/function (_Component) {
  function Sidebar() {
    var _this;
    _classCallCheck(this, Sidebar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Sidebar, [].concat(args));
    _defineProperty(_this, "scrollToTitle", function (e) {
      e.preventDefault(); // prevent default link navigation
      _this.props.scrollToItem(null)(TITLE_SCROLL_KEY);
    });
    _defineProperty(_this, "scrollToInfo", function (e) {
      e.preventDefault(); // prevent default link navigation
      _this.props.scrollToItem(null)(INSTRUCTIONS_SCROLL_KEY);
    });
    _defineProperty(_this, "scrollToResults", function (e) {
      e.preventDefault(); // prevent default link navigation
      _this.props.scrollToItem(null)(RESULTS_SCROLL_KEY);
    });
    _defineProperty(_this, "toggleSidebar", function () {
      var msg = _this.props.sidebarOpen ? t('Closed Sidebar') : t('Opened Sidebar');
      _this.props.screenreaderNotification(msg);
      _this.props.toggleSidebar();
    });
    _defineProperty(_this, "refWrapper", function (c) {
      _this.sidebarWrapper = c;
    });
    _defineProperty(_this, "handleBlur", function () {
      var isOpen = _this.props.sidebarOpen;
      setTimeout(function () {
        var focusNotInSidebar = _this.sidebarWrapper !== null && !_this.sidebarWrapper.contains(document.activeElement);
        if (_this.props.shouldCloseOnBlur && focusNotInSidebar && isOpen) {
          _this.toggleSidebar();
        }
      });
    });
    return _this;
  }
  _inherits(Sidebar, _Component);
  return _createClass(Sidebar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      // when the sidebar finishes its transition, fire a "windowResized" event
      // so that elements (such as hotspot canvas) know to update their size
      var resizeEvent = window.document.createEvent('UIEvents');
      resizeEvent.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(resizeEvent);
    }

    // ============
    //  RENDERING
    // ============
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var navigationText = t('Navigate to title');
      if (this.props.grading) {
        return;
      }
      return jsx("div", {
        css: this.props.styles.sidebar.actionableInfo,
        className: END_EDITING_TRIGGER_CLASSNAME
      }, jsx(Tooltip, {
        renderTip: this.props.sidebarOpen ? '' : jsx("span", {
          "aria-hidden": "true"
        }, navigationText),
        placement: "start",
        on: this.props.sidebarOpen ? [] : ['focus', 'hover']
      }, jsx(Link, {
        href: "#",
        margin: "small",
        forceButtonRole: false,
        onClick: this.scrollToTitle,
        renderIcon: jsx(IconQuizTitleLine, {
          color: "primary"
        }),
        "data-automation": "sidebar-title-button"
      }, jsx(ScreenReaderContent, null, navigationText))), jsx(PresentationContent, null, jsx("span", {
        css: this.props.styles.sidebar.description,
        "data-automation": "sidebar-title-text",
        onClick: this.scrollToTitle,
        tabIndex: "-1"
      }, this.props.title || t('Title'))));
    }
  }, {
    key: "renderInstructions",
    value: function renderInstructions() {
      var navigationText = t('Navigate to instructions');
      if (this.props.grading) {
        return;
      }
      return jsx("div", {
        css: this.props.styles.sidebar.actionableInfo,
        className: END_EDITING_TRIGGER_CLASSNAME
      }, jsx(Tooltip, {
        renderTip: this.props.sidebarOpen ? '' : jsx("span", {
          "aria-hidden": "true"
        }, navigationText),
        placement: "start",
        on: this.props.sidebarOpen ? [] : ['focus', 'hover']
      }, jsx(Link, {
        href: "#",
        margin: "small",
        forceButtonRole: false,
        onClick: this.scrollToInfo,
        renderIcon: jsx(IconQuizInstructionsLine, {
          color: "primary"
        }),
        "data-automation": "sidebar-instructions-button"
      }, jsx(ScreenReaderContent, null, navigationText))), jsx(PresentationContent, null, jsx("span", {
        css: this.props.styles.sidebar.description,
        "data-automation": "sidebar-instructions-text",
        onClick: this.scrollToInfo,
        tabIndex: "-1"
      }, t('Instructions'))));
    }
  }, {
    key: "renderResults",
    value: function renderResults() {
      var navigationText = t('Navigate to results');
      if (!this.props.grading) {
        return;
      }
      return jsx("div", {
        css: this.props.styles.sidebar.actionableInfo
      }, jsx(Tooltip, {
        renderTip: this.props.sidebarOpen ? '' : jsx("span", {
          "aria-hidden": "true"
        }, navigationText),
        placement: "start",
        on: this.props.sidebarOpen ? [] : ['focus', 'hover']
      }, jsx(Link, {
        href: "#",
        margin: "small",
        forceButtonRole: false,
        onClick: this.scrollToResults,
        renderIcon: jsx(IconQuizInstructionsLine, {
          color: "primary"
        }),
        "data-automation": "sidebar-results-button"
      }, jsx(ScreenReaderContent, null, navigationText))), jsx(PresentationContent, null, jsx("span", {
        css: this.props.styles.sidebar.description,
        "data-automation": "sidebar-results-text",
        onClick: this.scrollToResults,
        tabIndex: "-1"
      }, t('Results'))));
    }
  }, {
    key: "renderSidebarHeader",
    value: function renderSidebarHeader() {
      var _this$props = this.props,
        sidebarOpen = _this$props.sidebarOpen,
        styles = _this$props.styles;
      var SidebarIcon = sidebarOpen ? IconMoveStartLine : IconMoveEndLine;
      return jsx("div", {
        css: _objectSpread(_objectSpread({}, styles.headerSpacing), styles.headerBottomBorder)
      }, jsx("div", {
        css: styles.questionNavigatorPadding
      }, jsx(Heading, {
        level: "h5",
        as: "h2"
      }, t('Question Navigator'))), jsx("div", {
        css: styles.iconWrapper
      }, jsx(IconButton, {
        onClick: this.toggleSidebar,
        size: "small",
        margin: "none",
        renderIcon: SidebarIcon,
        withBackground: false,
        withBorder: false,
        screenReaderLabel: sidebarOpen ? t('Hide Question Navigator Menu') : t('Show Question Navigator Menu'),
        "data-automation": "sidebar-toggle-button"
      })));
    }
  }, {
    key: "renderTotalPointsPossible",
    value: function renderTotalPointsPossible() {
      var _this$props2 = this.props,
        sidebarOpen = _this$props2.sidebarOpen,
        totalPointsPossible = _this$props2.totalPointsPossible;
      if (typeof totalPointsPossible !== 'number') {
        return null;
      }
      var pointsText = jsx(Text, {
        key: "pointsText",
        size: "small",
        weight: "bold"
      }, t("{\n      totalPointsPossible, plural,\n       one {# pt}\n       other {# pts}\n      }", {
        totalPointsPossible: totalPointsPossible
      }));
      var responsiveText = pointsText;
      if (sidebarOpen) {
        responsiveText = jsx(Text, {
          size: "small"
        }, t.rich('Total question points = <points/>', {
          points: function points() {
            return pointsText;
          }
        }));
      }
      return jsx(View, {
        borderWidth: "0 0 small 0",
        padding: "small x-small",
        textAlign: sidebarOpen ? 'start' : 'center'
      }, jsx(AccessibleContent, {
        alt: t('Total question points = {totalPointsPossible}', {
          totalPointsPossible: totalPointsPossible
        })
      }, responsiveText));
    }
  }, {
    key: "renderPinned",
    value: function renderPinned() {
      var _this$props3 = this.props,
        sidebarOpen = _this$props3.sidebarOpen,
        taking = _this$props3.taking,
        pinnedItems = _this$props3.pinnedItems,
        scrollToItem = _this$props3.scrollToItem,
        styles = _this$props3.styles;
      if (!taking) {
        return;
      }
      return jsx("div", {
        css: _objectSpread(_objectSpread({}, styles.pinnedSection), styles.headerBottomBorder)
      }, jsx("div", {
        css: styles.headerSpacing
      }, jsx("div", {
        css: styles.buttonWrapper
      }, jsx(Heading, {
        level: "h5",
        as: "h2"
      }, t('Pinned Questions'))), jsx("div", {
        css: styles.iconWrapper,
        "aria-hidden": sidebarOpen
      }, jsx(Text, {
        size: "x-small",
        "aria-label": t('Pinned Questions'),
        role: "img"
      }, jsx(IconPinSolid, null)))), jsx("div", {
        css: styles.buttonWrapper
      }, pinnedItems.map(function (pin) {
        return jsx(Pin, {
          key: pin.sessionItemId,
          scrollToItem: scrollToItem,
          position: pin.position,
          sessionItemId: pin.sessionItemId
        });
      }).toArray()));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(View, null, jsx("div", {
        css: this.props.styles.commonContainer,
        id: "sidebar-wrapper",
        tabIndex: "-1"
      }, jsx("div", {
        css: this.props.styles.sidebar,
        onTransitionEnd: this.handleTransitionEnd,
        "data-automation": this.props.sidebarOpen ? 'sdk-sidebar-open' : 'sdk-sidebar-closed'
      }, jsx(Global, {
        styles: this.props.styles.globalStyles
      }), jsx("div", {
        css: this.props.styles.sidebarWrapper,
        ref: this.refWrapper,
        role: this.props.role,
        onBlur: this.handleBlur
        // for some reason, without a click handler here, a random item will
        // take the click and scroll to itself when the nav is clicked by SR
        ,
        onClick: noop,
        id: SIDEBAR_NAV_ID,
        "aria-label": t('Question Navigator')
      }, this.renderSidebarHeader(), this.renderTotalPointsPossible(), this.renderPinned(), this.renderTitle(), this.renderInstructions(), this.renderResults(), jsx("div", {
        css: this.props.styles.sidebarContent
      }, this.props.children)))));
    }
  }]);
}(Component), _defineProperty(_Sidebar, "displayName", 'Sidebar'), _defineProperty(_Sidebar, "componentId", "Quizzes".concat(_Sidebar.displayName)), _defineProperty(_Sidebar, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element), PropTypes.node]).isRequired,
  grading: PropTypes.bool,
  taking: PropTypes.bool,
  scrollToItem: CustomPropTypes.higherOrderFunction.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  pinnedItems: ImmutablePropTypes.listOf(PropTypes.shape({
    sessionItemId: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired
  })).isRequired,
  role: PropTypes.string,
  title: PropTypes.string,
  toggleSidebar: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  totalPointsPossible: PropTypes.number,
  shouldCloseOnBlur: PropTypes.bool,
  makeStyles: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_Sidebar, "defaultProps", {
  grading: false,
  taking: false,
  title: null,
  pinnedItems: List(),
  role: 'navigation',
  totalPointsPossible: null,
  shouldCloseOnBlur: onPhone()
}), _Sidebar)) || _class);
export default Sidebar;